import { IError } from './types'

//As actions servem para facilitar a chamada aos reducers
export function setError (error: IError) {
  return {
    type: 'SET_ERROR',
    payload: error
  }
}